<template>

</template>

<script>
    export default {
      name: "EarthQuake.vue",
      mounted: function () {
        window.location.href="https://cloudlark.pingxingyun.com:8180/enterAppli?appliId=844665981631463424&groupId=842391026202050560&codeRate=10000&frameRate=30&network=1"
      },
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/other/EarthQuake.vue